import React, { Component } from "react";
import { Link } from "react-router-dom";
import Particles from "react-tsparticles";
import "./softwareAndMobile.css";
import Footer from "../../../../components/Footer/Footer";
import ContactUsFooter from "../../../../components/ContactUsFooter/contactUsFooter";

export default class softwareAndMobile extends Component {

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <div>
                <div className="software-page">
                    <section className="software-hero">
                        <h1>Custom Software &<br />Mobile App Development</h1>
                    </section>

                    <section className="software-intro">
                        <h2>Innovative Software Solutions for the Future</h2>
                        <p>
                            Technology is evolving, and so are business needs. <br /> At Ambrum, we develop custom software
                            and mobile applications that drive efficiency, scalability, and seamless user experiences.
                            Whether you need an enterprise-grade ERP system, a customer-centric CRM, or a high-performance
                            mobile app, we turn ideas into reality.
                        </p>
                    </section>

                    <section className="why-choose">
                        <h3>Why Choose Ambrum?</h3>
                        <div className="features">
                            <div className="feature-box">
                                <img src="../assets/images/validation.gif" alt="Enterprise Icon" />
                                <p>Proven expertise in enterprise software, SaaS platforms, and mobile-first solutions</p>
                            </div>
                            <div className="feature-box">
                                <img src="../assets/images/agile.gif" alt="Agile Icon" />
                                <p>Agile development methodology ensuring flexibility and scalability</p>
                            </div>
                            <div className="feature-box">
                                <img src="../assets/images/helpdesk.gif" alt="Support Icon" />
                                <p>End-to-end support: UI/UX design, development, deployment, and maintenance</p>
                            </div>
                        </div>
                    </section>

                    <section className="approach">
                        <h3>Our Approach</h3>
                        <div className="approach-steps">
                            <div>
                                <h4>Requirement Analysis</h4>
                                <br />
                                <p>Understanding business <br /> objectives and defining <br />technical requirements</p>
                            </div>
                            <div className="approach-arrow">
                                <img src="../assets/images/fast-forward.gif" alt="Arrow" />
                            </div>
                            <div>
                                <h4>Custom Development</h4>
                                <br />
                                <p>Agile development <br />methodology ensuring <br />flexibility and scalability</p>
                            </div>
                            <div className="approach-arrow">
                                <img src="../assets/images/fast-forward.gif" alt="Arrow" />
                            </div>
                            <div>
                                <h4>Testing & Deployment</h4>
                                <br />
                                <p>Rigorous quality assurance <br /> to ensure flawless execution</p>
                            </div>
                        </div>
                    </section>

                    <div className="cta-section">
                        <Link to="/portfolio" className="cta-button">View Projects ❯</Link>
                    </div>
                    <ContactUsFooter />
                    <br />
                </div>
                <Footer />

            </div>
        );
    }
}
